import type { FaireProductEntity } from "../../entity_types/product";

export const p_kevdztuf8n: FaireProductEntity = {
  token: "p_kevdztuf8n",
  type: "product",
  name: "\u02bbAkahi & Laua\u02bbe Wrapping Paper",
  brandName: "NOHO HOME by Jalene Kanani",
  imageUrl:
    "https://cdn.faire.com/fastly/f416aa818d2ea72814045cf018f10f92d79f0e2a3e7dccbe541cc86f204378c6.png",
  priceDollars: 9,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ce98c46138135f2de81210e0626bc4a3b96b13a62dff5b137b8057a12286a8dc.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
